package dev.bitspittle.droidconSf24.pages.sections.conclusion

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Reveal4Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/conclusion/Reveal4.md", mapOf("layout" to listOf("center"), "data-auto-animate-restart" to listOf()))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            Vertical(Modifier.fontSize(2.5.cssRem), horizontalAlignment = Alignment.CenterHorizontally) {
                org.jetbrains.compose.web.dom.P {
                    FaGithub()
                    org.jetbrains.compose.web.dom.Text(" ")
                    com.varabyte.kobweb.compose.dom.GenericTag("a", "href=\"https://github.com/bitspittle/droidcon-sf-24\" style=\"margin-left:1rem\"") {
                        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/bitspittle/droidcon-sf-24") {
                            org.jetbrains.compose.web.dom.Text("https://github.com/bitspittle/droidcon-sf-24")
                        }
                    }
                }
                org.jetbrains.compose.web.dom.P {
                    FaImages()
                    org.jetbrains.compose.web.dom.Text(" ")
                    com.varabyte.kobweb.compose.dom.GenericTag("a", "href=\"https://bitspittle.github.io/droidcon-sf-24\" style=\"margin-left:1rem\"") {
                        com.varabyte.kobweb.silk.components.navigation.Link("https://bitspittle.github.io/droidcon-sf-24") {
                            org.jetbrains.compose.web.dom.Text("https://bitspittle.github.io/droidcon-sf-24")
                        }
                    }
                }
            }
        }
    }
}
